module.exports = __webpack_public_path__ + "static/media/About_sq.0cab27ca.md";